module.exports = __webpack_public_path__ + "img/1020_3.a3aa40a4.jpg";